export const returnCapitalizedIndexedCharacter = (index, string) => {
  if (!string) return '';
  if (index + 1 > string?.length) return '';
  return string?.split(' ')[index]?.substring(0, 1).toUpperCase();
};
